import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataStock(params) {
	return client.get('tunnel/api/stockist/stock/data', {
		params: params
	});
}

function getDataStockDaily(params) {
	return client.get('tunnel/api/stockist/stock/data-stock-daily2', {
		params: params
	});
}

function getDataStockLog(params) {
	return client.get('tunnel/api/stockist/stock/data_stock_log', {
		params: params
	});
}

function getDataStockSerial(params) {
	return client.get('tunnel/api/stockist/stock/data_stock_serial', {
		params: params
	});
}

function summarySerial () {
	return client.get('tunnel/api/stockist/stock/stock-serial-summary');
}

export default {
	getDataStock,
	getDataStockLog,
	getDataStockSerial,
	getDataStockDaily,
	summarySerial,
}